import {apiInstance} from "../../api"


export const getUserInfo = async () => {
  const url = '/user/info'
  return apiInstance.get(url)
  .then(res => res)
  .catch(err => err.response || err);
}
